import './App.css';
import {Grid} from "@mui/material";
import Pagina from "./Pagina/Pagina";
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/800.css';
import '@fontsource/poppins/900.css';
import '@fontsource/dm-serif-text/400.css';


function App() {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Pagina/>


        </Grid>
    );
}

export default App;
